<template>
  <div>
    <!-- 新增筛选区域 -->
    <el-row :gutter="10" style="margin-bottom: 15px;">
<!--      <el-col :span="6">
        <el-input v-model="searchForm.name" placeholder="名称" @keyup.enter.native="handleSearch"></el-input>
      </el-col>
      <el-col :span="6">
        <el-input v-model="searchForm.material_type" placeholder="物料类型" @keyup.enter.native="handleSearch"></el-input>
      </el-col>-->
      <el-col :span="4">
        <el-button type="primary" @click="handleAdd">添加</el-button>
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-col>
    </el-row>

<!--    <el-button type="primary" @click="handleAdd">新增</el-button>-->
    
    <el-table :data="tableDataShow" style="width: 100%" border>
      <el-table-column type="index" label="序号" width="80"></el-table-column>
      <el-table-column prop="name" label="名称" width="200"></el-table-column>
      <el-table-column prop="image" label="图片" width="80">
        <template slot-scope="scope">
          <el-popover placement="right" trigger="hover" v-if="scope.row.image">
            <img :src="('https://gate.yilanbiaoge.cn/back/getImage/'+scope.row.image)" style="width: 500px; height: 500px"/>
            <img slot="reference" :src="('https://gate.yilanbiaoge.cn/back/getImage/'+scope.row.image)" style="width: 40px; height: 40px"/>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="typeName" label="物料类型"width="200"></el-table-column>
      <el-table-column prop="warehouseName" label="所属仓库"></el-table-column>
      <el-table-column label="操作" width="400">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">详情</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
          <el-button size="mini" type="primary" @click="handleViewBom(scope.row)">查看BOM</el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 添加分页组件 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next"
      :total="total">
    </el-pagination>
    
    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible">
      <!-- 使用FormWithTabs组件展示详情 -->
      <FormWithTabs 
        v-if="dialogType === 'detail'"
        :data="form"
        :formInfo="formInfo"
        :tabs="tabsConfig"
        @input="handleFormInput"
      />
      <el-form v-else :model="form" ref="form" :rules="rules">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="简名" prop="shortName">
          <el-input v-model="form.shortName"></el-input>
        </el-form-item>
        <el-form-item label="规格" prop="specification">
          <el-input v-model="form.specification"></el-input>
        </el-form-item>
        <el-form-item label="型号" prop="model">
          <el-input v-model="form.model"></el-input>
        </el-form-item>
        <el-form-item label="产地" prop="origin">
          <el-input v-model="form.origin"></el-input>
        </el-form-item>
        <el-form-item label="厂商" prop="manufacturer">
          <el-input v-model="form.manufacturer"></el-input>
        </el-form-item>
        <el-upload
            class="avatar-uploader"
            action=""
            :show-file-list="false"
            :on-change="UploadImage">
          <img v-if="form.image" :src="('https://gate.yilanbiaoge.cn/back/getImage/'+form.image)" style="width: 500px; height: 500px" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <el-form-item label="物料类型" prop="typeName">
          <el-input v-model="form.material_type"></el-input>
        </el-form-item>
        <el-form-item label="所属仓库" prop="warehouseName">
          <WarehouseLov width="300px" :value="form.warehouseId" @callBack="setWarehouse"/>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button v-if="dialogType !== 'detail'" type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>

    <!-- 查看BOM对话框 -->
    <el-dialog title="物料BOM" :visible.sync="bomDialogVisible" width="80%">
      <MaterialBom :id="currentMaterialId" />
    </el-dialog>
  </div>
</template>

<script>
import requestTicket from '@/utils/requestTicket';
import MaterialBom from './MaterialBom.vue';
import WarehouseLov from "@/views/ticket/lov/WarehouseLov.vue";
import request from "@/utils/request";
// 引入FormWithTabs组件
import FormWithTabs from "@/views/element/FormWithTabs/FormWithTabs.vue";

export default {
  components: {
    WarehouseLov,
    MaterialBom,
    FormWithTabs
  },
  data() {
    return {
      tableData: [],
      tableDataShow: [],
      // 添加分页参数
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      bomDialogVisible: false,
      dialogTitle: '',
      dialogType: '', // 'detail' 或 'edit'
      currentMaterialId: null,
      form: {
        id: null,
        name: '',
        shortName: '',
        specification: '',
        model: '',
        origin: '',
        manufacturer: '',
        image: '',
        warehouseId: null,
        warehouseName: null,
        material_type: ''
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        material_type: [{ required: true, message: '请输入物料类型', trigger: 'blur' }]
      },
      searchForm: {
        name: '',
        material_type: ''
      },
      // FormWithTabs配置
      formInfo: {
        labelWidth: '100px',
        formMain: [
          { label: '名称', field: 'name', type: 'input', disabled: false },
          { label: '简名', field: 'shortName', type: 'input', disabled: false },
          { label: '规格', field: 'specification', type: 'input', disabled: false },
          { label: '型号', field: 'model', type: 'input', disabled: false },
          { label: '物料类型', field: 'material_type', type: 'input', disabled: false }
        ]
      },
      tabsConfig: [
        {
          name: '基础信息',
          formItems: [,
            { label: '产地', field: 'origin', type: 'input', disabled: false },
            { label: '厂商', field: 'manufacturer', type: 'input', disabled: false },
            { label: '所属仓库', field: 'warehouseName', type: 'input', disabled: false }
          ]
        },
        {
          name: '图片信息',
          formItems: [
            { label: '图片', field: 'image', type: 'image', disabled: false }
          ]
        }
      ]
    };
  },
  mounted() {
    this.handleSearch();
  },
  methods: {
    // 添加分页事件处理方法
    handleSizeChange(val) {
      this.pageSize = val;
      this.getTableDateShow();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableDateShow();
    },
    getTableDateShow() {
      this.tableDataShow = this.tableData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
    },
    
    // 打开新增对话框
    handleAdd() {
      this.dialogType = 'add';
      this.dialogTitle = '新增物料';
      this.form = { 
        id: null, 
        name: '', 
        shortName: '',
        specification: '',
        model: '',
        origin: '',
        manufacturer: '',
        image: '', 
        material_type: '' 
      };
      this.dialogVisible = true;
    },

    // 打开编辑对话框
    handleEdit(row) {
      this.dialogType = 'detail';
      this.dialogTitle = '物料详情';
      this.form = { ...row };
      this.dialogVisible = true;
    },

    // 打开查看BOM对话框
    handleViewBom(row) {
      this.currentMaterialId = row.id;
      this.bomDialogVisible = true;
    },

    // 提交表单（新增/修改）
    async submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            await requestTicket.post('/Ticketing/material/save', this.form);
            this.$message.success('操作成功');
            this.dialogVisible = false;
            await this.handleSearch();
          } catch (error) {
            console.error('操作失败:', error);
            this.$message.error('操作失败');
          }
        }
      });
    },

    // 删除数据
    async handleDelete(id) {
      try {
        await this.$confirm('确认删除该记录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        
        await requestTicket.delete(`/Ticketing/material/${id}`);
        this.$message.success('删除成功');
        await this.handleSearch();
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败:', error);
          this.$message.error('删除失败');
        }
      }
    },

    // 查询数据
    async handleSearch() {
      try {
        const response = await requestTicket.post('/Ticketing/procedure/execute', {
          procedureName: "get_material_p",
          parameters: []
        });
        this.tableData = response.data;
        this.total = response.data.length; // 假设返回总记录数在totalElements字段
        this.getTableDateShow();
      } catch (error) {
        console.error('获取数据失败:', error);
      }
    },
    setWarehouse(item){
      this.form.warehouseId = item.id
      this.form.warehouse = item.name
    },

    // 重置查询条件
    resetSearch() {
      this.handleSearch();
    },

    //上传图片的方法
    UploadImage(file,filelist) {
      let fd = new FormData()
      fd.append('file', file.raw) //传给后台接收的名字 file
      request.post('/upload/image', fd, {headers: {'Content-Type': 'multipart/form-data'}}).then(response => {
        //上传成功后返回的数据,
        // 将图片地址给到表单.
        this.form.image=response.data
      })
    },
    handleAvatarSuccess(res, file) {
      this.form.image = URL.createObjectURL(file.raw);
    },
    
    // FormWithTabs表单输入处理
    handleFormInput(value) {
      this.form = value;
    }
  }
};
</script>

<style scoped>
.el-button {
  margin-bottom: 15px;
  margin-right: 10px;
}
</style>